"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var walletAccessContext_1 = require("./walletAccessContext");
exports.initAccessContext = walletAccessContext_1.initAccessContext;
var wallet_1 = require("./wallet");
var wallet_2 = require("./wallet");
exports.initWallet = wallet_2.initWallet;
function initDefaultAccessContext(options) {
    exports.defaultAccessContext = walletAccessContext_1.initAccessContext(options);
    return exports.defaultAccessContext;
}
exports.initDefaultAccessContext = initDefaultAccessContext;
var WAL = {
    initDefaultAccessContext: initDefaultAccessContext,
    get accessContext() {
        if (!exports.defaultAccessContext) {
            throw new Error("\n        No default WalletAccessContext is configured. \n        Make sure to first run 'initDefaultAccessContext' to set it up.\n      ");
        }
        return exports.defaultAccessContext;
    },
    initWallet: wallet_1.initWallet
};
exports.default = WAL;
// force rebuild 2
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/eos-transit/lib/index.js
// module id = OHoK
// module chunks = 6